import React from "react";
import { useIsMobile } from "@utils/hooks";
import { CategoryEditorProps } from "./categoryEditorProps";
import { DesktopCategoryEditor } from "./desktopCategoryEditor";
import { MobileCategoryEditor } from "./mobileCategoryEditor";

export const CategoryEditor: React.FC<CategoryEditorProps> = ({ ...props }) => {
	const isMobile = useIsMobile();
	return isMobile ? <MobileCategoryEditor {...props} /> : <DesktopCategoryEditor {...props} />;
};
